import { render, staticRenderFns } from "./HeirloomList.vue?vue&type=template&id=79f9eda8"
import script from "./HeirloomList.vue?vue&type=script&lang=js"
export * from "./HeirloomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports